import { render, staticRenderFns } from "./BankInstructionIndex.vue?vue&type=template&id=19983a36&"
import script from "./BankInstructionIndex.vue?vue&type=script&lang=js&"
export * from "./BankInstructionIndex.vue?vue&type=script&lang=js&"
import style0 from "./BankInstructionIndex.vue?vue&type=style&index=0&id=19983a36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports